import React from "react";
import Appbar from "./Appbar";
import FooterF from "../Footer/FooterF";

const Main = ({ activePage }) => {
  return (
    <div>
      <Appbar />
      {activePage}
      <FooterF />
    </div>
  );
};

export default Main;
